/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pairContract",
                type: "address",
            },
        ],
        name: "PairListed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "TokenListed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "address",
                name: "pair",
                type: "address",
            },
        ],
        name: "addPairToMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
        ],
        name: "createMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "deletePairFromMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bank",
                type: "address",
            },
            {
                internalType: "address",
                name: "logic",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "address",
                name: "lpFactory",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "initialPoint",
                type: "int24",
            },
        ],
        name: "listPair",
        outputs: [
            {
                internalType: "address",
                name: "pairContract",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "url",
                type: "string",
            },
            {
                internalType: "string",
                name: "logo",
                type: "string",
            },
            {
                internalType: "address",
                name: "rule",
                type: "address",
            },
        ],
        name: "listToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "marketsByOwner",
        outputs: [
            {
                internalType: "string[]",
                name: "markets",
                type: "string[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "url",
                type: "string",
            },
            {
                internalType: "string",
                name: "logo",
                type: "string",
            },
            {
                internalType: "address",
                name: "rule",
                type: "address",
            },
        ],
        name: "modifyTokenInfo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
        ],
        name: "pairs",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "pair",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenX",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenY",
                        type: "address",
                    },
                ],
                internalType: "struct BitlyExchange.PairInfo[]",
                name: "pairs",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "setAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newLogic",
                type: "address",
            },
        ],
        name: "setLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newLpFactory",
                type: "address",
            },
        ],
        name: "setLpFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "tokenInfo",
        outputs: [
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "url",
                type: "string",
            },
            {
                internalType: "string",
                name: "logo",
                type: "string",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "rule",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "pair",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenX",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenY",
                        type: "address",
                    },
                ],
                internalType: "struct BitlyExchange.PairInfo[]",
                name: "pairs",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokens",
        outputs: [
            {
                internalType: "address[]",
                name: "listedTokens",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalMarkets",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferTokenOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class BitlyExchange__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
BitlyExchange__factory.bytecode = _bytecode;
BitlyExchange__factory.abi = _abi;
